import { onEnter } from "@/utils/keyboard/events";
import Input from "../../components/Input";
import StepLayout from "../../components/StepLayout";
import { SQFForm, SQFStepOf } from "../../hooks/useServiceQuoteFlow";
import { useStore } from "@tanstack/react-form";
import { isMobile } from "@/utils/is-mobile";

export default function ZipStep({ step, isFocused, form, onClickPrev }: Props) {
  const isMobileView = isMobile();

  const zip = useStore(form.store, (state) => state.values.zip);
  if (step?.hidden) return null;
  return (
    <StepLayout
      title={step.title()}
      onClickPrev={onClickPrev}
      buttonProps={{
        size: "lg",
        onClick: step.next,
        isDisabled: !step.canContinue(zip),
        className: "h-[44px] w-[170px] sm:w-[145px] sm:h-[50px]",
        disableHoverShadow: true,
      }}
      subtitle={"What is the project location?"}
      variant="shadow"
      hideDivider
      classNames={{
        headerTitleWrapper: "pl-[15px]",
        title: "text-[24px] leading-[28px] font-black text-left",
        subtitle: "text-left text-[18px] sm:text-auto",
      }}
    >
      <form.Field
        name="zip"
        validators={step.fields.zip.validators}
        listeners={{
          onBlur: () => {
            step.reset();
          },
          onChange: () => {
            step.reset()
            if (step.autoForward) {
              step.resolve();
            }
          }
        }}
        children={(field) => {
          const inputProps = step.fields.zip.props(field);
          return (
            <Input
              {...inputProps}
              type="tel"
              autoComplete="postal-code"
              size="lg"
              pattern="\d*"
              preset="weird-center"
              errorPreset={isMobileView ? "solid" : "float"}
              fullWidth={isMobileView}
              classNames={isMobileView ?
                {
                  base: "w-full",
                  input: "text-start text-md",
                  inputWrapper: "box-border py-0 group-data-[focus=true]:!border-medium",
                } : {
                  inputWrapper: "box-border py-0 rounded-[3px] shadow-none border-[color:rgb(203,195,180)] group-data-[focus=true]:!border-medium",
                }
              }
              autoFocus={isFocused}
              // @ts-expect-error type issue, but it's working
              onKeyDown={onEnter((e) => {
                (e.target as HTMLInputElement | undefined)?.blur?.();
                step.next();
              })}
              placeholder="Zip Code"
            />
          );
        }}
      />
    </StepLayout>
  );
}


interface Props {
  step: SQFStepOf<"zip">;
  form: SQFForm;
  onClickPrev?: () => void;
  isFocused: boolean;
}
